import { useState, useEffect, useRef } from "react";
import ReactPixel from "react-facebook-pixel";
import axios from "axios";

const useFacebookPixel = (usuario, options = {}) => {
  const [pixelId, setPixelId] = useState(null);
  const initializedRef = useRef(null);
  const { creadorId, campana, red = "facebook" } = options || {};

  useEffect(() => {
    if (!usuario) return;

    const fetchPixel = async () => {
      try {
        // 1) Intento legacy: endpoint por enlace (a veces solo cubre campañas video)
        let candidate = null;
        const response = await axios.get(`https://api.mrcirp.com/public/userpixels/${usuario}`);
        if (response.data && response.data.length > 0 && response.data[0]?.pixels) {
          candidate = response.data[0].pixels;
        }

        // 2) Fallback por campaña: buscar Pixel configurado para esa campaña del creador
        if (!candidate && creadorId && campana && red === "facebook") {
          try {
            const list = await axios.get(`https://api.mrcirp.com/public/pixels/${creadorId}`);
            const match = (list.data || []).find((r) => {
              const sameCamp = String(r?.campana || "").trim().toLowerCase() === String(campana).trim().toLowerCase();
              const sameRed = String(r?.red || "").trim().toLowerCase() === "facebook";
              return sameCamp && sameRed;
            });
            if (match?.pixels) candidate = match.pixels;
          } catch (e) {
            // ignorar: se mantiene candidate null
          }
        }

        if (candidate) {
          setPixelId(candidate);

          // Inicializar el Pixel con el ID del usuario
          if (initializedRef.current !== candidate) {
            ReactPixel.init(candidate, null, {
              autoConfig: true,
              debug: false,
            });
            initializedRef.current = candidate;
          }

          // Registrar la vista de página
          ReactPixel.pageView();
        }
      } catch (error) {
        console.error("Error obteniendo el Pixel de Facebook:", error);
      }
    };

    fetchPixel();
  }, [usuario, creadorId, campana, red]);

  // Función para rastrear el evento "Viewcotent"   
  const trackViewContent = () => {
    if (pixelId) {
      ReactPixel.track('ViewContent');
    } else {
      console.warn("Pixel no inicializado. No se puede rastrear el evento 'ViewContent'.");
    }
  };

  // Función para rastrear el evento "Cliente Potencial"
  const trackLead = () => {
    if (pixelId) {
      ReactPixel.track('Lead');
    } else {
      console.warn("Pixel no inicializado. No se puede rastrear el evento 'Lead'.");
    }
  };

 /// Función para rastrear el evento "Contact"
  const trackContact = () => {
    if (pixelId) {
      ReactPixel.track('Contact');
    } else {
      console.warn("Pixel no inicializado. No se puede rastrear el evento 'Contact'.");
    }
  };

   /// Función para rastrear el evento "Contact"
   const CompleteRegistration = () => {
    if (pixelId) {
      ReactPixel.track('CompleteRegistration');
    } else {
      console.warn("Pixel no inicializado. No se puede rastrear el evento 'CompleteRegistration'.");
    }
  };


  return {
    pixelId,
    trackViewContent,
    trackLead,
    trackContact,
    CompleteRegistration
  };
};

export default useFacebookPixel;